// de_cctv.ts
// Übersetzungen für das CCTV-Modul (CCTV.Host.tsx, CCTV.Dialogs.tsx).

export const deCctv = {
  errors: {
    cameraName: "Kameraname ist erforderlich.",
    cameraCode: "Der Kameracode darf Buchstaben, Zahlen, Punkte, Unterstriche und Bindestriche enthalten.",
    cameraConflict: "Eine Kamera mit diesem Code existiert bereits für dieses Haus.",
    cameraMissing: "Kamera für dieses Haus nicht gefunden.",
    cameraUnavailable: "Kamera für dieses Haus nicht verfügbar.",
    guestMask: "Fügen Sie eine Datenschutzmaske für den Gastbereich hinzu oder bestätigen Sie ausdrücklich die unmaskierte Ansicht.",
    masks: "Datenschutzmasken müssen eine Liste gültiger Bildbereiche sein.",
    maskRange: "Maske {{number}}: {{field}} muss ein Prozentwert zwischen 0 und 100 sein.",
    retentionRange: "{{field}} muss eine ganze Anzahl von Tagen zwischen 1 und 3650 sein.",
    retentionOrder: "Die Aufbewahrung für Vorfälle muss mindestens so lang wie die Standardaufbewahrung sein.",
    incidentTitle: "Vorfalltitel ist erforderlich.",
    incidentMissing: "Vorfall für dieses Haus nicht gefunden.",
    incidentEvents: "Ein oder mehrere Ereignisse gehören nicht zu diesem Haus.",
    eventAcknowledged: "Ereignis nicht gefunden oder bereits quittiert.",
    recordingMissing: "Aufzeichnung für dieses Haus nicht gefunden.",
    timelineRange: "Das Ende des Zeitraums muss nach seinem Anfang liegen.",
    request: "CCTV-Anfrage fehlgeschlagen ({{status}}).",
    unknown: "Ein unerwarteter Fehler ist aufgetreten. Versuchen Sie es erneut.",
    network: "Keine Verbindung zum Server. Prüfen Sie Ihre Verbindung und versuchen Sie es erneut.",
  },
  errorField: {
    retentionDays: "Aufbewahrungsfrist",
    standardRetentionDays: "Standardaufbewahrung",
    incidentRetentionDays: "Aufbewahrung für Vorfälle",
    x: "Horizontale Position",
    y: "Vertikale Position",
    width: "Breite",
    height: "Höhe",
  },
  auditAction: {
    "camera.created": "Kamera angelegt",
    "camera.updated": "Kamera aktualisiert",
    "event.recorded": "Ereignis erfasst",
    "event.acknowledged": "Ereignis quittiert",
    "incident.created": "Vorfall angelegt",
    "incident.updated": "Vorfall aktualisiert",
    "recording.playback": "Aufzeichnung abgespielt",
    "recording.export": "Aufzeichnung exportiert",
    "retention_policy.updated": "Aufbewahrungsrichtlinie aktualisiert",
  },
  auditEntity: {
    camera: "Kamera",
    event: "Ereignis",
    incident: "Vorfall",
    recording: "Aufzeichnung",
    retention_policy: "Aufbewahrungsrichtlinie",
  },
  zone: {
    guest: "Gastbereich",
    staff: "Personal",
    back_of_house: "Back of House",
    outdoor: "Außenbereich",
  },
  status: {
    online: "Live",
    offline: "Offline",
    alert: "Alarm",
    disabled: "Deaktiviert",
  },
  recordingMode: {
    continuous: "Daueraufnahme",
    event: "Ereignisgesteuert",
    disabled: "Keine Aufnahme",
  },
  source: {
    motion: "Bewegung",
    ai: "KI-Erkennung",
    access: "Zutritt",
    system: "System",
  },
  incidentStatus: {
    open: "Offen",
    investigating: "In Prüfung",
    closed: "Geschlossen",
  },
  severity: {
    low: "Niedrig",
    medium: "Mittel",
    high: "Hoch",
    critical: "Kritisch",
    info: "Information",
    warning: "Warnung",
  },
  incidentType: {
    security: "Sicherheit",
    theft: "Diebstahl",
    damage: "Sachschaden",
    noise: "Ruhestörung",
    maintenance: "Technik",
    operations: "Betrieb",
    other: "Sonstiges",
  },
  common: {
    loadFailed: "Daten konnten nicht geladen werden",
    retry: "Erneut versuchen",
    loading: "Wird geladen …",
    missingPermission: "Fehlende Berechtigung: {{key}}",
    hotelListUnavailable: "Hotelliste konnte nicht geladen werden.",
    refresh: "Aktualisieren",
    acknowledge: "Quittieren",
    days: "{{count}} Tage",
    days_one: "{{count}} Tag",
    days_few: "{{count}} Tage",
    days_many: "{{count}} Tage",
    days_other: "{{count}} Tage",
    never: "nie",
    unknown: "unbekannt",
    close: "Schließen",
    cancel: "Abbrechen",
    save: "Speichern",
    discard: "Verwerfen",
    none: "—",
  },
  nav: {
    live: "Live-Wand",
    cameras: "Kameras",
    recordings: "Aufzeichnungen",
    incidents: "Vorfälle",
    events: "Ereignisse",
    access: "Zutritt",
    privacy: "Datenschutz",
    health: "Systemzustand",
  },
  layout: {
    title: "Sicherheitszentrale",
    camerasOnline: "{{online}} von {{total}} Kameras online",
    openIncidents: "{{count}} offene Vorfälle",
    createIncident: "Vorfall anlegen",
    hotelListError: "Hotelliste konnte nicht geladen werden",
    resolvingHotel: "Hotel wird ermittelt …",
    property: "Hotel",
  },
  tile: {
    recording: "REC",
    noSignal: "Kein Signal",
    lastImage: "Letztes Bild {{time}}",
    masked: "Maskiert: {{label}}",
    maskedCount: "{{count}} maskiert",
    alerts: "{{count}} Alarme",
    recheck: "Erneut prüfen",
    open: "Vollansicht von {{name}} öffnen",
  },
  fullView: {
    subtitle: "{{code}} · {{location}}",
    noStream: "Das Livebild liefert der Adapter {{adapter}}. In dieser Browseransicht ist kein Stream angebunden.",
    lastSeen: "Letztes Signal",
    zone: "Zone",
    recording: "Aufnahme",
    retention: "Aufbewahrung",
    masks: "Maskierte Zonen",
    status: "Status",
    openAlerts: "Offene Alarme",
  },
  live: {
    subtitle: "{{property}} · Was passiert gerade, was braucht Aufmerksamkeit.",
    noKpis: "Keine Kennzahlen verfügbar",
    camerasOnline: "Kameras online",
    allReachable: "Alle erreichbar",
    withoutSignal: "{{count}} ohne Signal",
    openIncidents: "Offene Vorfälle",
    criticalCount: "{{count}} kritisch",
    noneCritical: "Keiner kritisch",
    aiEventsToday: "KI-Ereignisse heute",
    ofEventsTotal: "von {{count}} Ereignissen gesamt",
    retention: "Aufbewahrung",
    retentionDefault: "Noch nicht festgelegt · Standardwert",
    incidentRetention: "Vorfälle {{count}} Tage",
    noCameras: "Noch keine Kameras angelegt",
    noCamerasHint: "Unter „Kameras“ lässt sich die erste Kamera für dieses Haus einrichten.",
    attention: "Handlungsbedarf",
    attentionSummary: "{{incidents}} offene Vorfälle · {{alerts}} unquittierte Meldungen",
    nothingOpen: "Nichts Offenes",
    nothingOpenHint: "Keine offenen Vorfälle, alle Meldungen sind quittiert.",
    incidentOpened: "{{reference}} · eröffnet {{time}}",
  },
  cameras: {
    subtitle: "{{property}} · Standort, Zone, Aufnahmemodus und Aufbewahrung.",
    add: "Kamera hinzufügen",
    emptyHint: "Legen Sie die erste Kamera an, damit die Live-Wand etwas anzeigen kann.",
    colCamera: "Kamera",
    colLocation: "Standort",
    colZone: "Zone",
    colStatus: "Status",
    colRecording: "Aufnahme",
    colRetention: "Aufbewahrung",
    colPrivacy: "Datenschutz",
    colActions: "Aktionen",
    zonesMasked: "{{count}} Zonen maskiert",
    guestAreaUnmasked: "Gastbereich ohne Maske",
    edit: "Bearbeiten",
    activate: "Aktivieren",
    deactivate: "Deaktivieren",
  },
  recordings: {
    subtitle: "{{property}} · Wiedergabe im Beweismodus — jeder Zugriff wird protokolliert.",
    camera: "Kamera",
    density: "Ereignisdichte",
    densityHint: "Letzte 24 Stunden — leere Stunden muss niemand durchspulen.",
    noEvents: "Keine Ereignisse in diesem Zeitraum",
    noEventsHint: "Für diese Kamera wurden in den letzten 24 Stunden keine Ereignisse erfasst.",
    bucketTitle: "{{time}} · {{count}} Ereignisse",
    bucketCritical: ", davon {{count}} kritisch",
    clips: "Clips",
    clipCount: "{{count}} Aufzeichnungen",
    none: "Keine Aufzeichnungen",
    noneHint: "Für diese Kamera liegen keine gespeicherten Clips vor.",
    colStart: "Beginn",
    colDuration: "Dauer",
    colIncident: "Vorfall",
    linked: "verknüpft",
    evidence: "Beweismittel",
    normal: "Normal",
    play: "Abspielen",
    export: "Exportieren",
  },
  incidents: {
    subtitle: "{{property}} · Hergang aus Kamera, Schließanlage und System auf einer Achse.",
    list: "Vorfallliste",
    entries: "{{count}} Einträge",
    none: "Keine Vorfälle",
    noneHint: "Für dieses Haus wurde noch kein Vorfall angelegt.",
    eventCount: "{{count}} Ereignisse",
    sequence: "Hergang",
    pickOne: "Wählen Sie links einen Vorfall aus.",
    noneSelected: "Kein Vorfall ausgewählt",
    noneSelectedHint: "Die Zeitachse erscheint, sobald links ein Vorfall gewählt ist.",
    laneCamera: "Kamera",
    laneAi: "KI",
    laneAccess: "Zutritt",
    laneSystem: "System",
    noTimelineEvents: "Keine Ereignisse im Zeitfenster",
    noTimelineEventsHint: "Zu diesem Vorfall sind noch keine Kamera- oder Zutrittsereignisse erfasst.",
    timelineFoot: "Verknüpfte Ereignisse sind hervorgehoben; die übrigen liegen nur im selben Zeitfenster.",
  },
  events: {
    subtitle: "{{property}} · Bewegung, KI-Erkennung und Systemmeldungen.",
    open: "Offen",
    all: "Alle",
    none: "Keine Ereignisse",
    noneHint: "Für dieses Haus sind noch keine Ereignisse erfasst.",
    nothingOpenHint: "Alle Meldungen sind quittiert.",
    colTime: "Zeit",
    colSource: "Quelle",
    colEvent: "Ereignis",
    colConfidence: "Konfidenz",
    colAction: "Aktion",
    measured: "gemessen",
    acknowledged: "Quittiert",
  },
  access: {
    subtitle: "{{property}} · Ereignisse, die Keycoder über die Ingest-Schnittstelle meldet.",
    none: "Keine Zutrittsereignisse",
    noneHint: "Sobald Keycoder Ereignisse an POST /api/hotels/:id/cctv/events sendet, erscheinen sie hier und in der Vorfall-Zeitachse.",
  },
  privacy: {
    subtitle: "{{property}} · Aufbewahrungsfristen, Maskierung und Zugriffsprotokoll.",
    noPolicyTitle: "Noch keine Aufbewahrungsfrist festgelegt",
    noPolicyText: "Es greift der Standardwert von {{count}} Tagen. Solange nichts gespeichert ist, gibt es keine dokumentierte Entscheidung — für eine Betriebsvereinbarung oder eine Auskunft nach Art. 15 DSGVO ist das zu wenig.",
    retention: "Aufbewahrung",
    retentionHint: "Gilt für alle Kameras ohne eigene Frist.",
    noPolicy: "Richtlinie konnte nicht geladen werden",
    standardDays: "Standard (Tage)",
    incidentDays: "Vorfallgebunden (Tage)",
    saveFailed: "Speichern fehlgeschlagen.",
    lastChanged: "Zuletzt geändert: {{value}}",
    masking: "Maskierung",
    maskingHint: "Kameras in Gastbereichen ohne Maske.",
    openCount: "{{count}} offen",
    noOpenItems: "Keine offenen Punkte",
    noOpenItemsHint: "Jede Kamera in einem Gastbereich hat mindestens eine maskierte Zone.",
    withoutMask: "Ohne Maske",
    auditLog: "Zugriffsprotokoll",
    auditLogHint: "Wiedergabe, Export und Änderungen — revisionssicher.",
    noAudit: "Noch keine Einträge",
    noAuditHint: "Sobald jemand Aufnahmen ansieht oder exportiert, steht es hier.",
    colAction: "Aktion",
    colObject: "Objekt",
    colPerson: "Person",
  },
  health: {
    subtitle: "{{property}} · Adapter, erreichbare Kameras und Speicher.",
    recheck: "Neu prüfen",
    none: "Kein Systemzustand verfügbar",
    adapters: "Adapter",
    adaptersHint: "Anbieterneutral, pro Anbindung.",
    noAdapters: "Keine Kameras angebunden.",
    onlineOf: "{{online}} / {{total}} online",
    complete: "Vollständig",
    partial: "Lückenhaft",
    storage: "Speicher",
    storageHint: "Aufgezeichnetes Material.",
    clips: "Clips",
    totalDuration: "Gesamtdauer",
    evidenceLocked: "Als Beweismittel gesperrt",
    staleTitle: "Kameras ohne aktuelles Signal",
    staleHint: "Seit mehr als 15 Minuten nichts empfangen.",
    allReporting: "Alle Kameras melden sich",
    allReportingHint: "Kein Gerät ist länger als 15 Minuten stumm.",
    neverSeen: "nie gesehen",
  },
  dialogs: {
    busySaving: "Speichert …",
    busyCreating: "Wird angelegt …",
    editCamera: "Kamera bearbeiten · {{code}}",
    addCamera: "Kamera hinzufügen",
    editCameraHint: "Änderungen werden im Zugriffsprotokoll festgehalten.",
    addCameraHint: "Code und Name sind erforderlich.",
    saveChanges: "Änderungen speichern",
    createCamera: "Kamera anlegen",
    name: "Name",
    namePlaceholder: "Flur Etage 3",
    code: "Code",
    location: "Standort",
    locationPlaceholder: "Etage 3, Ostflügel",
    zone: "Zone",
    recordingMode: "Aufnahmemodus",
    retentionDays: "Aufbewahrung (Tage)",
    maskedZones: "Maskierte Zonen · Angaben in Prozent des Bildes",
    noMaskedZone: "Keine Zone maskiert.",
    maskLabel: "Bezeichnung",
    maskLabelPlaceholder: "Liegestühle",
    remove: "Entfernen",
    addZone: "Zone hinzufügen",
    maskZoneLabel: "Zone {{count}}",
    unmaskedAck: "Diese Kamera filmt einen Gastbereich ohne maskierte Zone. Das ist eine bewusste Entscheidung, die im Protokoll festgehalten wird.",
    saveFailed: "Speichern fehlgeschlagen.",
    createFailed: "Anlegen fehlgeschlagen.",
    createIncident: "Vorfall anlegen",
    createIncidentHint: "Die Vorfallnummer wird automatisch vergeben.",
    title: "Titel",
    titlePlaceholder: "Wiederholter Zutrittsversuch Zimmer 314",
    type: "Typ",
    severity: "Schweregrad",
    status: "Status",
    camera: "Kamera",
    noCamera: "Keine Kamera",
    accessLog: "Zutrittsprotokoll-Referenz",
    assignedTo: "Zugewiesen an",
    assignedToPlaceholder: "Nachtdienst",
    description: "Beschreibung",
    descriptionPlaceholder: "Was ist passiert, was wurde bereits unternommen?",
  },
};

export default deCctv;
